$(window).on(" load resize orientationchange", function () {
  
  if($(".banner:hidden").length == 0) {
    $(".wrapper-wrapper").css("top", $('.site-header').innerHeight());
    // $("#mobile-menu").css("height", `calc(100vh - ${bannerHeight})`);

    if ($('body').hasClass('admin-bar')) {
      $(".wrapper-wrapper").css("top", $('.site-header').innerHeight() + $('#wpadminbar').innerHeight());
      $(".scroll-wrapper").css("top", $('.site-header').innerHeight() + $('#wpadminbar').innerHeight());
      $(".mobile-nav").css("height", "calc(100vh - " + $('.site-header').innerHeight() + ")");
      $(".mobile-nav").css("top", $('.site-header').innerHeight() + $('#wpadminbar').innerHeight());
    } else {
      $(".wrapper-wrapper").css("top", $('.site-header').innerHeight());
      $(".scroll-wrapper").css("top", $('.site-header').innerHeight());
      $(".mobile-nav").css("height", "calc(100vh - " + $('.site-header').innerHeight() + ")");
      $(".mobile-nav").css("top", $('.site-header').innerHeight());
    }

  }
});

// User Type Prompt
$(window).on(" load resize orientationchange", function () {
    $(".banner__close-button-image").on('click', function () {
        $("#banner").css("display", "none");
        $(".site-header").css("top", "inherit");

        // $("#sidebar").css("top", $('.site-header').innerHeight());
        // $("#sidebar").css("height", "calc(100vh - 62px)");
        
        if ($('body').hasClass('admin-bar')) {
          $(".wrapper-wrapper").css("top", $('.site-header').innerHeight() + $('#wpadminbar').innerHeight());
          $(".scroll-wrapper").css("top", $('.site-header').innerHeight() + $('#wpadminbar').innerHeight());
          $(".mobile-nav").css("height", "calc(100vh - " + $('.site-header').innerHeight() + ")");
          $(".mobile-nav").css("top", $('.site-header').innerHeight() + $('#wpadminbar').innerHeight());
        } else {
          $(".wrapper-wrapper").css("top", $('.site-header').innerHeight());
          $(".scroll-wrapper").css("top", $('.site-header').innerHeight());
          $(".mobile-nav").css("height", "calc(100vh - " + $('.site-header').innerHeight() + ")");
          $(".mobile-nav").css("top", $('.site-header').innerHeight());
        }

        createCookie("cc_should_hide_banner", true, 30);

    });
});

$(document).ready(function() {

  function hideBar() {
    $("#banner").css("display", "none");
    $(".site-header").css("top", "0px");

    $("#sidebar").css("top", $('.site-header').innerHeight());
    $("#sidebar").css("height", "calc(100vh - 62px)");
    $("#mobile-menu").css("top", $('.site-header').innerHeight());
    $("#mobile-menu").css("height", "calc(100vh - 62px)");
    $(".scroll-wrapper").css("top", $('.site-header').innerHeight());

  }

  $("#wholesale-selector").on("click", function() {

    $("#consumer-selector").find(".wholesale-lover").removeClass("selected-customer-type");

    $(this).find(".wholesale-lover").addClass("selected-customer-type");

    $("[data-visibility-wholesale='false']").css({'visibility': 'hidden', 'display': 'none'})
    .removeClass("grid-item");

    $("[data-visibility-wholesale='true']").css({'visibility': 'visible', 'display': 'block'})
    .addClass("grid-item");

    $(".grid").packery("layout");

    // hideBar();

    $.ajax({
      type: "POST",
      url: loading_vars.ajaxurl,
      data: {
        'action' : 'cc_set_customer_type',
        'customer_type' : 'wholesale'
      },
      success: function(data) {
        console.log(data);


      }
    });


  });

  $("#consumer-selector").on("click", function() {

    $("#wholesale-selector").find(".wholesale-lover").removeClass("selected-customer-type");

    $(this).find(".wholesale-lover").addClass("selected-customer-type");

    $("[data-visibility-consumer='false']").css({'visibility': 'hidden', 'display': 'none'})
    .removeClass("grid-item");

    $("[data-visibility-consumer='true']").css({'visibility': 'visible', 'display': 'block'})
    .addClass("grid-item");

    $(".grid").packery("layout");

    // hideBar();


    $.ajax({
      type: "POST",
      url: loading_vars.ajaxurl,
      data: {
        'action' : 'cc_set_customer_type',
        'customer_type' : 'consumer'
      },
      success: function(data) {
        console.log("SET SOMETHING");
        console.log(data);
      }
    });

  });

});

// Cookie Stuff

function createCookie(name,value,minutes) {
	var expires = "";
	if (minutes) {
			var date = new Date();
			date.setTime(date.getTime() + (minutes*60*1000));
			expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for(var i=0;i < ca.length;i++) {
				var c = ca[i];
				while (c.charAt(0)==' ') c = c.substring(1,c.length);
				if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
		}
		return null;
}

function eraseCookie(name) {
		createCookie(name,"",-1);
}
